import { useMutation } from '@tanstack/react-query';
import * as z from 'zod';

import { type MembershipGroupCardTag } from 'src/features/memberships/types';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/membership-groups/:membershipGroupId/tags/';

type FormSchemaValues = z.infer<typeof formSchema>;
const formSchema = z.object({
    text: z.string().min(1),
    theme: z.string().min(1),
});

interface DTO extends FormSchemaValues {
    parkingId: string;
    membershipGroupId: number;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, membershipGroupId, ...data }: DTO): Promise<MembershipGroupCardTag> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, membershipGroupId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export {
    RESOURCE as CREATE_MEMBERSHIP_GROUP_CARD_TAG_RESOURCE,
    useMutationHook as useCreateMembershipGroupCardTag,
    formSchema as createMembershipGroupCardTagFormSchema,
};
export type {
    DTO as CreateMembershipGroupCardTagDTO,
    FormSchemaValues as CreateMembershipGroupCardTagFormSchemaValues,
};
